module.exports = __webpack_public_path__ + "static/assets/221fd064155f0e103dc635916e7aa7a4.png";